import { camelize } from 'frontend-utils/utils/convert-case';
import {
  CALCULATED_PROPERTIES,
  CALCULATED_PROPERTIES_NO_PERCENTAGE,
} from 'lumen/utils/constants/ri-constant-values';

/**
 * @param {object} segmentationValue
 * @param {boolean} showPercentage wether to calculate the values for raw values or values and percentages
 * @param {?string} kpiCategory the currently selected kpiCategory (f.e. total or transient)
 * @returns {object} an object containing all values rounded, and a max property for each value
 */
export default function roundSegmentationValue(
  segmentationValue,
  showPercentage = false,
  kpiCategory = null,
) {
  if (segmentationValue && segmentationValue.calculatedValues) {
    const roundedValues = {};
    const maxValues = {};

    const calcProps = showPercentage
      ? CALCULATED_PROPERTIES
      : CALCULATED_PROPERTIES_NO_PERCENTAGE;

    calcProps.forEach((property) => {
      const objValues = {};

      if (segmentationValue.calculatedValues[property]) {
        Object.keys(segmentationValue.calculatedValues[property]).forEach(
          (calculatedValueKey) => {
            let value =
              segmentationValue.calculatedValues[property][calculatedValueKey];

            if (calculatedValueKey === 'message') {
              objValues[calculatedValueKey] = value;
              return;
            }

            /**
             * If there is no value for the given kpi (short key), use kpi_kpiCategory (long key) as key for value and maxValue.
             * @see module:lumen/app/components/hotel-and-market/revenue-insight/tables/rows/tooltip-revenue-insight-row.js.TooltipRevenueInsightRow#values
             */
            if (
              (value === null || value === undefined) &&
              kpiCategory !== null
            ) {
              value =
                segmentationValue.calculatedValues[property][
                  camelize(`${calculatedValueKey}_${kpiCategory}`)
                ];
            }

            objValues[calculatedValueKey] =
              !Number.isNaN(value) && value !== null ? Math.round(value) : null;

            if (
              !maxValues[calculatedValueKey] ||
              maxValues[calculatedValueKey] < objValues[calculatedValueKey]
            ) {
              maxValues[calculatedValueKey] = objValues[calculatedValueKey];
            }
          },
        );
      }

      roundedValues[property] = objValues;
    });

    roundedValues.max = maxValues;

    return roundedValues;
  }

  return null;
}
